import styled from 'styled-components';

export const ContactFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 10px 10px 10px;
  font-size: 14px;
  min-width: 240px;
`;

export const ContactForm = styled.form``;

export const ConctactIcons = styled.div`
  margin-bottom: 16px;
`;

export const ContactIcon = styled.a`
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 8px;
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const FormLabel = styled.label`
  font-size: 13px;
  margin-bottom: 2px;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 4px 6px;
  border: 1px solid #B3B3B3;
  &:focus {
    outline: 3px solid #99C4F5;
    border-radius: 2px;
  }
  ${(props) =>
    props.error &&
    `
    border-color: #C51B00;
  `}
`;

export const FormTextArea = styled.textarea`
  width: 100%;
  border: 1px solid #B3B3B3;
  &:focus {
    outline: 3px solid #99C4F5;
    border-radius: 2px;
  }
  ${(props) =>
    props.error &&
    `
    border-color: #C51B00;
  `}
`;

export const FormSubmit = styled.button`
  min-width: 120px;
  background-color: #FEFEFE;
  border: 1px solid #CACACA;
  border-radius: 4px;
  padding: 4px 8px;
  cursor: pointer;
  transition: background-color ease 0.2s;
  :hover {
    background-color: #EFEFEF;
  }
`;

export const ResultMessage = styled.p`
  padding-top: 32px;
  padding-bottom: 32px;
`
